import React from 'react';
import AppRoutes from '../routes';
import Footer from '../components/eternalgosh/footer';
import Header from '../components/eternalgosh/header';
import HomePage from '../pages/eternalgosh/home_page';
import MediaRoom from '../pages/eternalgosh/media_room';

export default function EternalgoshTemplate(props) {
    return (
        <React.Fragment>
            <Header />
            <AppRoutes
                homePage={HomePage}
                mediaRoom={MediaRoom}
            />
            <Footer />
        </React.Fragment>
    )
}
